import { isMobileDevice, isPWA } from '../utils/capacitor';

/**
 * Returns true only when on an actual mobile device (user agent) or PWA.
 * Desktop with a narrow/shrunk browser window stays desktop — no viewport-based switching.
 */
export const useMobile = (): boolean => isMobileDevice() || isPWA();

